import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react'
import SheetCapture from './ctn/SheetCapture';
import $ from 'jquery';
import { utils, writeFile } from 'xlsx';
import { capitalizeFLetter, ajaxPerso, socketPerso, loadMinSellingPrices, loadShippingCostPerSku } from '../fnc'
import moment from 'moment';
import 'react-data-grid/lib/styles.css';
import DataGrid from 'react-data-grid';
import ExcelJS from 'exceljs';
const refConst = require("../constants.js").v

const {info, log, warn} = console
const initialState = {
	dataSheet: null,
	submited: false
};


export default function AddToXlsx(props){

	let stickyHeader = (item) => {
		// console.info('itemitemitemitem', item);
		return <span className="mr-2">{item.column.name}</span>;
	}

	const defaultColumnProperties = {
		resizable: true,
		headerRenderer: stickyHeader
	}

	const apiProperty = [{
		api: "eio",
		id: refConst.id_store_eio,
		hasAccess: props.securityClearance(props, [
			"-MjVxK86GVBUKL5oNU66", // admin_access
		]),
		shop: refConst.id_store_eio,
		fnc: () => {
			console.info("dataSheet", dataSheet);
			dataSheet.fullData.forEach(o => {
				delete o.modified
			})
			createReport('Report', dataSheet.fullData)
		},
		triggers: [{
			idName: "add_min_selling_price",
			name: "Add minimum selling price",
			trigger: null,
			required: ["sku"],
			alert: <div className="alert alert-primary text-break text-wrap" role="alert">
				By clicking on Trigger, the system will add a column per store with the minimum selling price at the end of your excel file and download the file.
			</div>
		},{
			idName: "add_shipping_cost",
			name: "Add Shipping Cost",
			trigger: null,
			required: ["sku"],
			alert: <div className="alert alert-primary text-break text-wrap" role="alert">
				By clicking on Trigger, the system will add a column per store with the shipping cost at the end of your excel file and download the file.
				<ul>
					<li>shipping_cost: represent the true shipping cost.</li>
					<li>true_shipping_cost: Indicate if the true shipping was found.</li>
					<li>calculated_cost: is the cost calculated by the system from our Shipstation grabber.</li>

				</ul>
			</div>
		},{
			idName: "add_amazon_price_limits",
			name: "Add Amazon Price Limits",
			trigger: null,
			required: ["sku"],
			alert: <div className="alert alert-primary text-break text-wrap" role="alert">
				By clicking on Trigger, the system will add columns for Amazon minimum and maximum allowed prices at the end of your excel file and download the file.
				<ul>
					<li>min_allowed_price: The minimum price allowed for the item on Amazon.</li>
					<li>max_allowed_price: The maximum price allowed for the item on Amazon.</li>
				</ul>
			</div>
		}]
	}].filter(o => {
		if(o.hasAccess)	return o
	})

	const [selectedOption, setSelectedOption] = useState(0);
	const [selectedTrigger, setSelectedTrigger] = useState(0);
	const [dataSheet, setDataSheet] = useState(initialState.dataSheet);
	const [submited, setSubmited] = useState(initialState.submited);
	const [items, setItems] = useState([]);
	const lastProcessedRef = useRef(null);

	const columns = useMemo(() => {
		if(!dataSheet || dataSheet.fullData.length === 0)	return []
		return Object.keys(dataSheet.fullData[0]).map(k => (
			Object.assign({
				key: k,
				name: k
			}, defaultColumnProperties)
		))
	}, [dataSheet?.fullData, items])

	useEffect(() => {
		info('dataSheet', dataSheet);

		if(dataSheet && dataSheet.listObj && dataSheet.listObj.length > 0){
			// Skip if we've already processed this exact listObj reference
			if(lastProcessedRef.current === dataSheet.listObj){
				return
			}

			let apiProp = apiProperty[selectedOption],
				trigger = apiProp.triggers[selectedTrigger]

			console.info('apiProp', apiProp);
			console.info('trigger', trigger);
			
			// Mark as processing
			lastProcessedRef.current = dataSheet.listObj
			
			fetchItems({
				api: apiProp.api,
				shop: apiProp.shop,
				addShipping: true
				// verbose: true
			}, (r) => {
				props.loading(false)
				console.info(`Fetching_getItems_getItems`, r);
				if(r.success){
					if(trigger.idName === "add_min_selling_price"){
						addMinSellingPrices(r.data.filter(o => {
							if(o.weight_unit && o.weight)	return o
						}), (r) => {
							console.info("addMinSellingPrices", r);
							setItems(r)
						})
					}else if(trigger.idName === "add_amazon_price_limits"){
						addAmazonPriceLimits(r.data, (r) => {
							console.info("addAmazonPriceLimits", r);
							setItems(r)
						})
					}else{
						// Should add the true shinning if existing, if not the calculated one
						addShippingCost(r.data, (r) => {
							console.info("addShippingCost", r);
							setItems(r)
						})
					}
				}
			})
		} else {
			// Reset the ref when dataSheet is cleared
			lastProcessedRef.current = null
		}

	}, [dataSheet?.listObj, selectedOption, selectedTrigger])

	useEffect(() => {
		resetPage()
	}, [selectedOption])

	useEffect(() => {
		props.loading(submited)
	}, [submited])
	
	let resetPage = () => {
		for (const key in initialState) {
			if (initialState.hasOwnProperty(key)) {
				let val = JSON.parse(JSON.stringify(initialState[key]))
				console.info('Eval result', eval("set" + capitalizeFLetter(key))(val));
			}
		}
	}

	const createReport = async (title, list) => {

		// The upload button create the excel and let the user download it
		const workbook = new ExcelJS.Workbook();
		const worksheet = workbook.addWorksheet(title);

		if(list.length === 0)
			return;

		// First, define the columns based on the first row's keys
		const columns = Object.keys(list[0]).map(key => ({
			header: key,
			key: key,
			width: 15
		}));

		// Set the columns
		worksheet.columns = columns;

		// Then add all rows at once
		worksheet.addRows(list);

		// Add auto-filter
		worksheet.autoFilter = {
			from: { row: 1, column: 1 },
			to: { row: 1, column: Object.keys(list[0]).length }
		};

		// Freeze first row
		worksheet.views = [
			{ state: 'frozen', xSplit: 0, ySplit: 1 }
		];

		// Make the file
		console.info("worksheetworksheetworksheet", worksheet);
		const buffer = await workbook.xlsx.writeBuffer();
			
		// Create a Blob from the buffer
		const blob = new Blob([buffer], {
			type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
		});

		// Create download link and trigger download
		const url = window.URL.createObjectURL(blob);
		const anchor = document.createElement('a');
		anchor.href = url;
		anchor.download = `Result_${title}_${moment().local().format('YYYY-MM-DD hh:mm:ss')}.xlsx`;

		// Append to body, click and remove
		document.body.appendChild(anchor);
		anchor.click();
		document.body.removeChild(anchor);

		// Clean up the URL
		window.URL.revokeObjectURL(url);
		props.loading(false)
		setSubmited(false)
	}

	const addShippingCost = (listItems, callback) => {

		console.info("addShippingCost listItems", listItems);
		loadShippingCostPerSku(listItems.map(o => o.sku), (dr) => {
			console.info("addShippingCost response", dr);
			
			// Check if we have valid data
			if(!dr || !dr.success || !dr.data || !Array.isArray(dr.data) || dr.data.length === 0){
				console.warn("addShippingCost: No data returned from loadShippingCostPerSku", dr);
				callback(listItems)
				return;
			}

			// Create a new array to trigger React re-render
			let updatedFullData = dataSheet.fullData.map((d, index) => {
				let columnKeyName = dataSheet.columnName[0]
				let excelSku = d[columnKeyName]

				// Normalize SKU for comparison (trim and convert to string)
				if(excelSku != null){
					excelSku = String(excelSku).trim()
				} else {
					// Still return d with default empty fields so columns are consistent
					return Object.assign({}, d, {
						true_shipping_cost: "",
						found_true_shipping_cost: false,
						calculated_shipping_cost: "",
						calculated_shipping_carrier: "",
						calculated_shipping_base_weight: "",
						modified: true
					})
				}

				// Find matching item with case-insensitive and trimmed comparison
				let minFound = dr.data.find(d2 => {
					if(!d2 || !d2.sku) return false
					return String(d2.sku).trim().toLowerCase() === excelSku.toLowerCase()
				})

				if(minFound){
					return Object.assign({}, d, {
						true_shipping_cost: minFound?.shipping_cost ?? "",
						found_true_shipping_cost: minFound?.true_margin_found ?? false,
						calculated_shipping_cost: minFound?.calculated_cost ?? "",
						calculated_shipping_carrier: minFound?.calculated_carrier_name ?? "",
						calculated_shipping_base_weight: minFound?.calculated_base_weight ?? "",
						modified: true
					})
				} else {
					// Add empty fields if not found so headers appear
					return Object.assign({}, d, {
						true_shipping_cost: "",
						found_true_shipping_cost: false,
						calculated_shipping_cost: "",
						calculated_shipping_carrier: "",
						calculated_shipping_base_weight: "",
						modified: true
					})
				}
			})

			// Update state to trigger re-render
			setDataSheet({
				...dataSheet,
				fullData: updatedFullData
			})
			
			callback(listItems)
		})
	}

	const addMinSellingPrices = (listItems, callback) => {

		if(listItems.length === 0 || !refConst.stores || refConst.stores.length === 0)	return;

		let args = [];
		listItems.forEach(d => {
			args.push({
				sku: d.sku,
				weight: d.weight,
				weight_unit: d.weight_unit,
				cost: d.cost,
				shipping_cost: d.avg_shipping_cost
			})
		})

		loadMinSellingPrices(args, (dr) => {
			console.info("addMinSellingPrices", dr);
			
			// Check if we have valid data
			if(!dr || !dr.success || !dr.data || !Array.isArray(dr.data) || dr.data.length === 0){
				console.warn("addMinSellingPrices: No data returned from loadMinSellingPrices", dr);
				callback(listItems)
				return;
			}

			// First, collect ALL potential store keys from the response to ensure all rows get them
			let allStoreKeys = new Set(["map_price"]);
			dr.data.forEach(minFound => {
				if (minFound.minSellingPrice) {
					for (const idStore in minFound.minSellingPrice) {
						let storeName = refConst.stores.find(s => s.id == idStore)?.name
						if(storeName){
							allStoreKeys.add(`Min ${storeName}`)
						} else {
							allStoreKeys.add(`Min Store ${idStore}`)
						}
					}
				}
			})

			// Create a new array to trigger React re-render
			let updatedFullData = dataSheet.fullData.map((d, index) => {
				let columnKeyName = dataSheet.columnName[0]
				let excelSku = d[columnKeyName]

				// Initialize all store keys with empty strings for this row
				let rowUpdates = {}
				allStoreKeys.forEach(key => rowUpdates[key] = "")
				rowUpdates.modified = true

				// Normalize SKU for comparison (trim and convert to string)
				if(excelSku != null){
					excelSku = String(excelSku).trim()
				} else {
					console.warn(`addMinSellingPrices: No SKU found in column ${columnKeyName} for row ${index}`)
					return Object.assign({}, d, rowUpdates)
				}

				// Find matching item with case-insensitive and trimmed comparison
				let minFound = dr.data.find(d2 => {
					if(!d2 || !d2.sku) return false
					return String(d2.sku).trim().toLowerCase() === excelSku.toLowerCase()
				})
				
				let minFoundFinale = listItems.find(d2 => {
					if(!d2 || !d2.sku) return false
					return String(d2.sku).trim().toLowerCase() === excelSku.toLowerCase()
				})

				if(minFound){
					for (const idStore in minFound.minSellingPrice) {
						if (Object.prototype.hasOwnProperty.call(minFound.minSellingPrice, idStore)) {
							let min = minFound.minSellingPrice[idStore]
							if(minFoundFinale?.map_price && parseFloat(minFoundFinale.map_price) > parseFloat(min))
								min = parseFloat(minFoundFinale.map_price)
							
							let storeName = refConst.stores.find(s => s.id == idStore)?.name
							let key = storeName ? `Min ${storeName}` : `Min Store ${idStore}`
							rowUpdates[key] = min
							
							if(minFoundFinale?.map_price) {
								rowUpdates[`map_price`] = minFoundFinale.map_price
							}
						}
					}
				} else {
					console.warn(`addMinSellingPrices: No matching min price found for SKU "${excelSku}" in row ${index}`)
				}
				
				return Object.assign({}, d, rowUpdates)
			})

			// Update state to trigger re-render
			setDataSheet({
				...dataSheet,
				fullData: updatedFullData
			})
			
			callback(listItems)
		})
	}

	const addAmazonPriceLimits = (listItems, callback) => {
		console.info("addAmazonPriceLimits", listItems);
		
		// Check if we have valid data
		if(!listItems || !Array.isArray(listItems) || listItems.length === 0){
			console.warn("addAmazonPriceLimits: No items provided", listItems);
			callback(listItems)
			return;
		}

		// Create a new array to trigger React re-render
		let updatedFullData = dataSheet.fullData.map((d, index) => {
			let columnKeyName = dataSheet.columnName[0]
			let excelSku = d[columnKeyName]
			
			// Define default fields
			let updateFields = {
				min_allowed_price: "",
				max_allowed_price: "",
				modified: true
			}

			// Normalize SKU for comparison (trim and convert to string)
			if(excelSku != null){
				excelSku = String(excelSku).trim()
			} else {
				console.warn(`addAmazonPriceLimits: No SKU found in column ${columnKeyName} for row ${index}`)
				return Object.assign({}, d, updateFields)
			}

			// Find matching item with case-insensitive and trimmed comparison
			let itemFound = listItems.find(d2 => {
				if(!d2 || !d2.sku) return false
				return String(d2.sku).trim().toLowerCase() === excelSku.toLowerCase()
			})

			if(itemFound){
				updateFields.min_allowed_price = itemFound?.min_allowed_price ?? ""
				updateFields.max_allowed_price = itemFound?.max_allowed_price ?? ""
			} else {
				console.warn(`addAmazonPriceLimits: No matching item found for SKU "${excelSku}" in row ${index}`)
			}
			
			return Object.assign({}, d, updateFields)
		})

		// Update state to trigger re-render
		setDataSheet({
			...dataSheet,
			fullData: updatedFullData
		})
		
		callback(listItems)
	}

	const triggerPageFnc = () => {
		if(!dataSheet){
			props.info({error: "Please select a file, a sheet and a column to compare it with your marketplace."})
		}else{
			setSubmited(true)
			apiProperty[selectedOption].fnc()
		}
	}

	const fetchItems = (args, callback) => {
		props.loading(true)

		let listSku = dataSheet.listObj.map((o) => {
			return 	o.sku;
		})

		let apiProp = apiProperty[selectedOption],
			trigger = apiProp.triggers[selectedTrigger]

		let ajaxArgs = {
			"trigger": "getItems",
			"skuListJson": JSON.stringify(listSku),
		}

		// Merge args first
		ajaxArgs = Object.assign(ajaxArgs, args)

		// Override with Amazon settings for Amazon price limits trigger
		if(trigger.idName === "add_amazon_price_limits"){
			ajaxArgs.api = "amazon"
			ajaxArgs.shop = refConst.id_store_amazon_EIO
			ajaxArgs.propertyList = ["sku_on_amazon as sku", "min_allowed_price", "max_allowed_price"].join(',')
		}

		ajaxPerso(ajaxArgs, callback);
	}

	let addGrid = () => {
		
		if(dataSheet.fullData.length === 0)	return;
		console.info('itemsitemsitems', dataSheet.fullData);

		// We make sure that we have no object for the render in our grid
		dataSheet.fullData.map(o => {
			for (const key in o) {
				if (Object.hasOwnProperty.call(o, key)) {
					if(typeof o[key] === "object")
						o[key] = JSON.stringify(o[key])
				}
			}
		})

		return <DataGrid
			headerRenderer={stickyHeader}
			columns={columns}
			rows={dataSheet.fullData}
		/>
	}

	if(!props.securityClearance(props))	return "";

	console.info("refConst.stores", refConst.stores);

	return (
		<div className="main ctnPage">
			<h1 className="page-header mb-4">{props.title}</h1>
			<div id="mainMenu" className="container mb-3 bg-light border p-3">
				{
					apiProperty.map((s, posMain) => {
						console.info("selectedTriggerselectedTrigger", selectedTrigger);
						console.info("selectedTriggerselectedTrigger22", s.triggers[selectedTrigger].alert);
						return <div key={posMain}>
							{
								selectedTrigger !== null && posMain !== null? <div className="alertAdded">
									{s.triggers[selectedTrigger].alert}
								</div> : ''
							}
							<p className="font-weight-bolder">Select the primary type of data to use for your update</p>
							{
								s.triggers.map((s, pos) => {
									return <SheetCapture key={`${pos}_${s.required}_sheetCapture`} className={"ml-4"} dataSheet={dataSheet} onChange={(val) => {
										setDataSheet(val)
										setItems([])
									}} onClick={() => {
										setSelectedOption(posMain)
										setSelectedTrigger(pos)
									}} isActive={selectedTrigger === pos} name={<div>
										<div>{s.name}</div>
										<div>From Sheet [by: {s.required.join(', ')}]</div>
									</div>} valuesAllowed={"valuesAllowed" in s? s.valuesAllowed : null} {...props} returnAll={true} returnObjectFullData={true} required={Array.isArray(s.required)? s.required : [s.required]}/>
								})
							}
						</div>
					})
				}
			</div>
			{
				dataSheet? <div className="container mt-4 bg-light p-3 border">
					<p className="font-weight-bolder">Informations</p>
					<div className="row">
						<div className="col-sm">
							Line number:
						</div>
						<div className="col-sm">
							<span className="font-weight-bolder">{ dataSheet.fullData.length > 0? dataSheet.fullData.length : 0 }</span>
						</div>
					</div>
					<div className="row">
						<div className="col-sm">
							The column selected:
						</div>
						<div className="col-sm">
							<span className="font-weight-bolder">{ dataSheet.columnName }</span>
						</div>
					</div>
					<div className="row">
						<div className="col-sm">
							Items found:
						</div>
						<div className="col-sm">
							<span className="font-weight-bolder">{ items.length }</span>
						</div>
					</div>
					<div className="row">
						<div className="col-sm">
							Data added to: 
						</div>
						<div className="col-sm">
							<span className="font-weight-bolder">{ dataSheet.fullData.filter(o => {
								if(o.modified)	return o
							}).length }</span>
						</div>
					</div>
					<div className="row">
						<div className="col-sm">
							<span className="font-weight-bolder">{ addGrid() }</span>
						</div>
					</div>
					<div className="row">
						<div className="col justify-content-center text-center mt-3">
							<button type="button" className="btn btn-primary btn-lg" disabled={items.length === 0 || !dataSheet || submited? true : false} onClick={() => {triggerPageFnc()}}>Trigger</button>
						</div>
					</div>
				</div> : ''
			}
		</div>
	);
}